

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface AccidentTypeParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface AccidentType {
    id?: number;
    name: string;
    
  parameters?: AccidentTypeParameter[];
  links?: any;
}

export abstract class AccidentTypeData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(): Observable<AccidentType[]>;
  abstract create(url: string,data: AccidentType): Observable<any>;
  abstract update(url: string,data: AccidentType): Observable<any>;
  abstract delete(url: string): Observable<any>;
}